import {
  fetchActivesAndUsedCategories,
  fetchCategories,
  fetchCategory,
  fetchMultipleCategories,
  fetchReapproCategories,
  fetchReapproCategoryAlgorithms,
} from '../queries/categories.queries'

import { queryOptions, skipToken, useQuery } from '@tanstack/react-query'

export const useCategories = () =>
  useQuery({
    queryKey: ['categories'],
    queryFn: fetchCategories,
  })

const reapproCategoriesOptions = queryOptions({
  queryKey: ['reapproCategories'],
  queryFn: fetchReapproCategories,
  staleTime: 60_000,
})

export const useReapproCategories = () => useQuery(reapproCategoriesOptions)

export const useReapproCategory = (id?: number) =>
  useQuery({
    ...reapproCategoriesOptions,
    select: (data) => data.find((category) => category.id === id),
    enabled: id !== undefined && !Number.isNaN(id),
  })

const reapproCategoryAlgorithmsOptions = queryOptions({
  queryKey: ['reapproCategoryAlgorithms'],
  queryFn: fetchReapproCategoryAlgorithms,
  staleTime: 60_000,
})

export const useReapproCategoryAlgorithms = () => useQuery(reapproCategoryAlgorithmsOptions)

export const useActivesAndUsedCategories = (storeId: number) =>
  useQuery({
    queryKey: ['activesAndUsedCategories', storeId],
    queryFn:
      Number.isNaN(storeId) || storeId === 0
        ? skipToken
        : () => fetchActivesAndUsedCategories(storeId),
  })

export const useCategory = (id?: number) =>
  useQuery({
    queryKey: ['category', id],
    queryFn: id ? () => fetchCategory(id) : skipToken,
  })

export const useMultipleCategories = (ids: number[]) =>
  useQuery({
    queryKey: ['multipleCategories', ids],
    queryFn: () => {
      if (ids.length === 0) {
        return []
      }
      return fetchMultipleCategories(ids)
    },
  })
